import { render, staticRenderFns } from "./CommentPopUp.vue?vue&type=template&id=55a26544&scoped=true&"
import script from "./CommentPopUp.vue?vue&type=script&lang=js&"
export * from "./CommentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CommentPopUp.vue?vue&type=style&index=0&id=55a26544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a26544",
  null
  
)

export default component.exports